module.exports = fox._r("fonts/amc-cf.svg", __webpack_public_path__ + "_/_/_/root/fonts/amc-cf.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/amc-cf.svg
// module id = 220
// module chunks = 4